'use strict'

angular.module('internal.accountDashboard', ['ngAnimate', 'ui.bootstrap'])
    .config(['$stateProvider', '$urlRouterProvider', function ($stateProvider, $urlRouterProvider) {
        $stateProvider
            // internal routings
            .state('internal.login', {
                url: '/login',
                templateUrl: paths.app + 'dashboard/components/dashboard/dashboard.html',
                controller: 'InternalDashboard',
                params: {
                    allowAnonymous: true
                },
                resolve: {
                    permission: ['$state', '$rootScope', 'PortalPermissions', function ($state, $rootScope, PortalPermissions) {
                        $rootScope.$state.current = this.self;
                    }]
                }
            })
            .state('internal.oidcLogin', {
                url: '/oidc/login',
                templateUrl: paths.app + 'dashboard/components/dashboard/dashboard.html',
                controller: 'InternalDashboard',
                params: {
                    allowAnonymous: true
                },
                resolve: {
                    permission: ['$state', '$rootScope', 'PortalPermissions', function ($state, $rootScope, PortalPermissions) {
                        $rootScope.$state.current = this.self;
                    }]
                }
            })
            .state('internal.oidcCallback', {
                url: '/oidc_callback',
                templateUrl: paths.app + 'dashboard/components/dashboard/dashboard.html',
                controller: 'InternalDashboard',
                params: {
                    allowAnonymous: true
                },
                resolve: {
                    permission: ['$state', '$rootScope', 'PortalPermissions', function ($state, $rootScope, PortalPermissions) {
                        $rootScope.$state.current = this.self;
                    }]
                }
            })
            .state('internal.twoFactorAuthentication', {
                url: '/two_factor_authentication/:id',
                templateUrl: paths.app + 'dashboard/components/dashboard/dashboard.html',
                controller: 'InternalDashboard',
                params: {
                    allowAnonymous: true,
                    id: null
                },
                resolve: {
                    permission: ['$state', '$rootScope', 'PortalPermissions', function ($state, $rootScope, PortalPermissions) {
                        $rootScope.$state.current = this.self;
                    }]
                }
            })
            .state('internal.forgotPassword', {
                url: '/forgot_password',
                templateUrl: paths.app + 'dashboard/components/dashboard/dashboard.html',
                controller: 'InternalDashboard',
                params: {
                    allowAnonymous: true
                },
                resolve: {
                    permission: ['$state', '$rootScope', 'PortalPermissions', function ($state, $rootScope, PortalPermissions) {
                        $rootScope.$state.current = this.self;
                    }]
                }
            })
            .state('internal.changePassword', {
                url: '/change_password/:id/',
                templateUrl: paths.app + 'dashboard/components/dashboard/dashboard.html',
                controller: 'InternalDashboard',
                params: {
                    allowAnonymous: true
                },
                resolve: {
                    permission: ['$state', '$rootScope', 'PortalPermissions', function ($state, $rootScope, PortalPermissions) {
                        $rootScope.$state.current = this.self;
                    }]
                }
            })
            // dashboard tab
            .state('internal.accountDashboard', {
                abstract: true,
                templateUrl: paths.app + 'dashboard/components/dashboard/dashboard.html',
                controller: 'InternalDashboard',
                params: {
                }
            })
            .state('internal.accountDashboard.privacyStatement', {
                url: '/dashboard/privacy_statement',
                templateUrl: paths.app + 'dashboard/components/dashboard/dashboard.html',
                controller: 'InternalDashboard',
                params: {
                },
            })
            .state('internal.preview', {
                url: '/dashboard/preview/:previewUserId/:previewPageName',
                templateUrl: paths.app + 'dashboard/components/preview/preview.html',
                controller: 'InternalDashboardPreview',
                params: {
                    previewUserId: null,
                    previewPageName: null
                },
                resolve: {
                    permission: ['$state', '$rootScope', 'PortalPermissions', function ($state, $rootScope, PortalPermissions) {
                        $rootScope.$state.current = this.self;
                        return PortalPermissions.view(this.self.name).then(function (access) {
                            if (!access) {
                                //$state.go('portal.menus.denied');
                            }
                        });
                    }]
                }
            })
            .state('internal.accountDashboard.account.updatePassword', {
                url: '/dashboard/account/edit',
                templateUrl: paths.app + 'setup/components/setup-react/setup-react.html',
                controller: 'InternalSetupReact',
                params: {
                    allowAnonymous: false
                },
            })
    }])
;